import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { styled } from '@material-ui/core'
import clsx from 'clsx'

// Typings
// type PriceAtomProps = {
//   className: string
//   disableSuperscript: boolean
//   price: string | number
//   strikeThrough: boolean
// }

// Styles
const Sup = styled('sup')({
  fontSize: '50%',
  verticalAlign: 'super',
  '&.with-space': {
    '&--left': {
      marginLeft: '0.125em',
    },
    '&--right': {
      marginRight: '0.125em',
    },
  },
  '&:empty': {
    display: 'none',
  },
})

const Span = styled('span')({
  position: 'relative',
  textWrap: 'nowrap',
  '&.disabled-sup, &.strike-through': {
    '& sup': {
      fontSize: 'inherit',
      verticalAlign: 'inherit',
    },
  },
  '&.strike-through': {
    textDecoration: 'line-through',
  },
  '&.sale': {
    color: '#E11F21',
  },
  '&.bold': {
    fontWeight: '600',
  },
})

// Helpers
const getPriceStrings = price => {
  try {
    if (typeof price === 'string') {
      if (price[0] === '$') {
        return price.slice(1).split('.')
      }
      return price.split('.')
    }
    return price.toString().split('.')
  } catch {
    return ['Invalid Price']
  }
}

// Component
const PriceAtom = memo(function PriceAtom({
  className,
  dataTestId,
  price,
  disableSuperscript,
  strikeThrough,
  bold,
  suppressCentsIfZero = false,
  sale = false,
}) {
  const [dollars, cents] = getPriceStrings(typeof price === 'number' ? price.toFixed(2) : price)

  return (
    <Span
      className={clsx(
        className,
        strikeThrough && 'strike-through',
        disableSuperscript && 'disabled-sup',
        bold && 'bold',
        sale && 'sale',
      )}
      data-testid={dataTestId}
    >
      {price !== '--' && <Sup>$</Sup>}
      {dollars}
      {((suppressCentsIfZero && cents > 0) || !suppressCentsIfZero) && (
        <>
          {cents && !strikeThrough && <span className="hide508">.</span>}
          <Sup className={clsx(!strikeThrough && 'with-space--left')}>
            {cents && strikeThrough && <span>.</span>}
            {cents}
          </Sup>
        </>
      )}
    </Span>
  )
})

PriceAtom.propTypes = {
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  disableSuperscript: PropTypes.bool,
  price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  strikeThrough: PropTypes.bool,
  suppressCentsIfZero: PropTypes.bool,
  bold: PropTypes.bool,
  sale: PropTypes.bool,
}

export default PriceAtom
